<template>
  <div>
    <label >{{ $t('insights.ui.dateProperties') }}</label>
    <template v-for="(dateProperty, index) in getDatePropertiesToCount">
      <div class="custom-control custom-checkbox" v-bind:key="'dateProperty-' + uniqueId + index">
        <input v-model="datePropertyValues[dateProperty]"
               @change="setDatePropertiesToConfig"
               :value="true"
               type="checkbox" :id="'dateProperty-' + uniqueId + index"
               class="custom-control-input"
        >
        <label class="custom-control-label" :for="'dateProperty-' + uniqueId + index">
          <span>{{  $t('insights.ui.dateProperty.' + dateProperty) }}</span>
        </label>
      </div>
    </template>
  </div>
</template>

<script>
import generalMethods from "@/mixins/insights/generalMethods";
import {mapGetters} from "vuex";

export default {
  mixins: [generalMethods],
  name: "DatePropertiesToInclude",
  props: ['editing', 'currentConfig'],
  data() {
    return {
      uniqueId: _.uniqueId(),
      datePropertyValues: {}
    }
  },
  computed: {
    ...mapGetters('company', ['getConfig']),
    getDatePropertiesToCount() {
      return this.getConfig.datePropertiesToCount;
    }
  },
  methods: {
    setDatePropertiesToConfig() {
      this.config.componentConfig.datePropertiesToCount = this.datePropertyValues;
      this.emitConfig();
    }
  },
  created(){
    this.config = this.currentConfig;
    if (!this.config.componentConfig.datePropertiesToCount) {
      this.config.componentConfig.datePropertiesToCount = {};
    }
    this.datePropertyValues = this.config.componentConfig.datePropertiesToCount;
  }

}
</script>

<style scoped>

</style>